module.exports = __webpack_public_path__ + "static/media/img-loading.a6178f44.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/img-loading.gif
 ** module id = 110
 ** module chunks = 0
 **/